import { forwardRef, useState } from 'react';
import styles from './InputPassword.module.scss';
import Input from '../Input';
import Icon from '../Icon';
import classNames from 'classnames';

/**
 * InputPassword
 *
 * @return {JSX.Element}
 */
const InputPassword = (props, ref) => {
  const [show, setShow] = useState(false);

  const toggleShowHide = () => setShow((c) => !c);

  return (
    <Input
      {...props}
      className={styles.InputPassword}
      type={show ? 'text' : 'password'}
      fullWidth
      ref={ref}
      after={
        <Icon
          name="passShow"
          onClick={toggleShowHide}
          className={classNames(
            styles.ShowHide,
            !show && styles.ShowHide__hide
          )}
        />
      }
    />
  );
};

InputPassword.displayName = 'InputPassword';

export default forwardRef(InputPassword);
